import { useMutation, useQueryClient } from "@tanstack/react-query"

import type {
  GuildRankTitle,
  GuildSpecialTitle,
} from "@/core/guild-members/titles"

import { toast } from "@/components/ui/toast"
import { memberTitlesApi } from "@/lib/member-titles-api"
import { activityPointsKeys, adminMembersKeys } from "@/lib/query-keys"

export type UpdateMemberTitlesVariables = {
  memberId: string
  rankTitle: GuildRankTitle | null
  specialTitles: GuildSpecialTitle[]
}

export const useUpdateMemberTitlesMutation = (
  authenticatedMemberId: string | null,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({
      memberId,
      rankTitle,
      specialTitles,
    }: UpdateMemberTitlesVariables) =>
      memberTitlesApi.update(memberId, { rankTitle, specialTitles }),
    onSuccess: (_item, variables) => {
      const invalidations = [
        queryClient.invalidateQueries({
          queryKey: adminMembersKeys.detail(variables.memberId),
        }),
        queryClient.invalidateQueries({
          queryKey: activityPointsKeys.all,
        }),
      ]
      if (variables.memberId === authenticatedMemberId) {
        invalidations.push(
          queryClient.invalidateQueries({
            queryKey: ["profile", authenticatedMemberId] as const,
          }),
        )
      }
      return Promise.all(invalidations)
    },
    onError: (error: Error) => toast.error(error.message),
  })
}
